module.exports = __webpack_public_path__ + "static/img/traffic-light-yellow.1ec0302.png";